import { render } from "./notificationSettings.vue?vue&type=template&id=05e4bb12&scoped=true"
import script from "./notificationSettings.vue?vue&type=script&lang=js"
export * from "./notificationSettings.vue?vue&type=script&lang=js"

import "./notificationSettings.vue?vue&type=style&index=0&id=05e4bb12&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e4bb12"]])

export default __exports__